import { RachelDockedLayout } from '../rachel.types';
import { useRachelStore } from '../store/rachel.store';
import { selectRachelDockedLayout } from '../store/rachel.store.selectors';
import { useIsRachelDocked } from './useIsRachelDocked';

export const useRachelDockedLayout = (): RachelDockedLayout | null => {
  const isDocked = useIsRachelDocked();
  const dockedLayout = useRachelStore(selectRachelDockedLayout);

  return isDocked ? dockedLayout : null;
};
